// components/templates/sections/STORY_COFFEE.tsx
import React from "react";
import { CoffeeBean } from "./CoffeeBean";
import { useDesign } from "@/context/DesignContext";

type StoryProps = { title?: string; description?: string; year?: number; design?: any };

export default function STORY_COFFEE({ title = "Obsession over Convenience", description = "Vertrin was born from frustration...", year = 15, design: propDesign }: StoryProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const primaryColor = design?.colors?.primary || "#C8622A";
  const secondaryColor = design?.colors?.secondary || "#E8A45A";
  const bgColor = design?.colors?.background || "#0C0500";
  const textColor = design?.colors?.text || "#F5E6D3";
  const textLightColor = design?.colors?.textLight || "#BFA76A";
  const containerMaxWidth = design?.spacing?.containerMaxWidth || "1280px";

  return (
    <section id="story" className="py-32 mx-auto px-8" style={{ maxWidth: containerMaxWidth }}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
        <div className="relative">
          <div className="w-80 h-80 rounded-full mx-auto relative" style={{ background: `radial-gradient(circle at 40% 40%, #2d1407, ${bgColor})` }}>
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="absolute" style={{ top: "50%", left: "50%", transform: `rotate(${i * 90}deg) translateX(160px) rotate(-${i * 90}deg)` }}>
                <CoffeeBean size={24} opacity={0.5} rotate={i * 45} />
              </div>
            ))}
            <div className="absolute inset-8 rounded-full flex items-center justify-center" style={{ border: `1px solid ${primaryColor}33` }}>
              <div className="text-center">
                <div className="font-display text-6xl font-black" style={{ color: primaryColor }}>{year}</div>
                <div className="font-mono-custom text-xs tracking-widest uppercase" style={{ color: `${textLightColor}99` }}>Years of<br/>Craft</div>
              </div>
            </div>
          </div>
          <div className="absolute -bottom-6 -right-6 p-5 backdrop-blur-sm border" style={{ background: `${bgColor}E6`, borderColor: `${primaryColor}33` }}>
            <div className="font-mono-custom text-xs tracking-widest mb-1" style={{ color: primaryColor }}>THIS MONTH</div>
            <div className="font-display text-lg font-bold" style={{ color: textColor }}>Burundi Kibira</div>
            <div className="font-mono-custom text-xs" style={{ color: `${textLightColor}80` }}>Washed · Light Roast</div>
          </div>
        </div>
        <div>
          <div className="font-mono-custom text-xs tracking-[0.5em] uppercase mb-6" style={{ color: primaryColor }}>◈ Our Story</div>
          <h2 className="font-display text-6xl font-black leading-none mb-8" style={{ color: textColor }}>
            {title.split("\n").map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}
          </h2>
          <p className="text-xl leading-relaxed mb-6" style={{ fontStyle: "italic", color: `${textLightColor}B3` }}>{description}</p>
          <button className="font-mono-custom text-sm tracking-widest uppercase px-10 py-4 transition-all duration-300"
                  style={{
                    border: `1px solid ${primaryColor}80`,
                    color: textLightColor,
                    background: "transparent"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = primaryColor;
                    e.currentTarget.style.color = bgColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = textLightColor;
                  }}>
            Read Full Story →
          </button>
        </div>
      </div>
    </section>
  );
}